import Browser from '@wetransfer/transfer/modules/concorde-browser';

export const MESSAGE_CUTOFF_POINT = Browser.isMobile ? 170 : 55;
